import { z } from 'zod';

/**
 * Wire contract for the signal-only Copilot history push on the
 * /notification Socket.IO namespace. The server emits it to the session
 * owner after a CopilotMessage write; clients re-read history through the
 * authorized query instead of polling. The payload never carries content.
 */
export const COPILOT_HISTORY_CHANGED_EVENT = 'copilot:history-changed';

export const copilotHistoryChangedEventV1Schema = z.object({
  sessionId: z.string().min(1),
  docId: z.string().nullable(),
  timestamp: z.number().finite(),
});
export type CopilotHistoryChangedEventV1 = z.infer<
  typeof copilotHistoryChangedEventV1Schema
>;
